import { render, staticRenderFns } from "./DocumentArchiveSelector.vue?vue&type=template&id=6dd4b7e0&scoped=true&"
import script from "./DocumentArchiveSelector.vue?vue&type=script&lang=ts&"
export * from "./DocumentArchiveSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentArchiveSelector.vue?vue&type=style&index=0&id=6dd4b7e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd4b7e0",
  null
  
)

export default component.exports